export default __webpack_public_path__ + "182b42d9384d243b51d5e9a5c722fca9.svg";